import request from "@/utils/request";

export default function applyMerchant(wechatMpId, params) {
    return request({
        url: `/merchant/agency/apply/${wechatMpId}`,
        method: 'post',
        data: params
    })
}
